import layoutComponents from './layout-components'
import formComponents from './form-components'
import buttonComponents from './button-components'
import dataComponents from './data-components'
import othersComponents from './others-components'
import businessComponents from './business-components'

const install = Vue => {
  Vue.use(layoutComponents)
  Vue.use(formComponents)
  Vue.use(buttonComponents)
  Vue.use(dataComponents)
  Vue.use(othersComponents)
  Vue.use(businessComponents)
}

export default {
  rowBtns: buttonComponents.rowBtns,
  formGroup: formComponents.formGroup,
  tableEditItem: dataComponents.tableEditItem,
  province: formComponents.province,
  city: formComponents.city,
  district: formComponents.district,
  selectTree: formComponents.selectTree,
  bdcSelect: formComponents.bdcSelect,
  editItem: formComponents.editItem,
  remarkCell: formComponents.remarkCell,
  editCell: formComponents.editCell,
  textareaCell: formComponents.textareaCell,
  towCascader: formComponents.towCascader,
  towTileSelect: formComponents.towTileSelect,
  install
}
